import {restoreOfferTemplate} from "@project/sdk/sales";
import {RestoreOfferTemplateResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../offerTemplate-keys";

export function restoreOfferTemplateMutationOptions() {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.restoreOfferTemplate,
    mutationFn: async (id: string) =>
      RestoreOfferTemplateResponse.parse(await restoreOfferTemplate(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
